import StoneLogDetail from './StoneLogDetail'

export default StoneLogDetail
